import { render, staticRenderFns } from "./AppUpdater.vue?vue&type=template&id=6509d062&scoped=true&"
import script from "./AppUpdater.vue?vue&type=script&lang=ts&"
export * from "./AppUpdater.vue?vue&type=script&lang=ts&"
import style0 from "./AppUpdater.vue?vue&type=style&index=0&id=6509d062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6509d062",
  null
  
)

export default component.exports